import { render, staticRenderFns } from "./ApiTokens.vue?vue&type=template&id=190a8b25&scoped=true"
import script from "./ApiTokens.vue?vue&type=script&lang=js"
export * from "./ApiTokens.vue?vue&type=script&lang=js"
import style0 from "./ApiTokens.vue?vue&type=style&index=0&id=190a8b25&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190a8b25",
  null
  
)

export default component.exports